import api from "./api";

// Tela /saude: visao geral operacional da empresa ativa (admin).
const platformService = {
  health: () => api.get("/platform/health").then((r) => r.data),
};

export default platformService;
